import { awardRoutes } from './awards'
import { engagementRoutes } from './engagement'
import { partnerRoutes } from './partners'

export function routes () {
  this.timing = 3000
  if (window.Cypress) {
    this.timing = 10;
  }

  awardRoutes.call(this),
  partnerRoutes.call(this)
  engagementRoutes.call(this)

  this.passthrough(`${this.urlPrefix}/**`)
  this.passthrough('https://brasilapi.com.br/api/cep/v2/**')
  this.passthrough('https://visits.visitor-analytics.io/api/standalone/outgoing-traffic/')
  this.passthrough('**')
  this.passthrough('**/**')
}



// WEBPACK FOOTER //
// ./src/mocks/routes/index.js